import {
  FaUserFriends,
  FaMoneyBillWave,
  FaLeaf,
  FaHeart,
  FaStar,
  FaQuestion,
  FaEnvelope,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";
import BossBottomTab from "./components/boss-bottom-tab";
import { useEffect, useState } from "react";
import HeaderLiveSales from "./components/header/header-live-sales";
import { GET_SELLER_STORE } from "./api/seller-store";
import { track } from "@amplitude/analytics-browser";
import BottomSheet from "../../components/common/bottom-sheet";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import FadeInWrapper from "../../components/common/fade-in-wrapper";
import { NoticeModal } from "./components/notice-modal";
import FeeChangeModal from "./components/fee-change-modal";
import SettlementChangeModal, {
  SETTLEMENT_CHANGE_NOTICE_URL,
} from "./components/settlement-change-modal";
import LegacyUnsettledModal from "./components/legacy-unsettled-modal";
import INTRO_IMG1 from "./1.png";
import INTRO_IMG2 from "./2.png";
import INTRO_IMG3 from "./3.png";
import INTRO_IMG4 from "./pre-order/image/3.png";

import { IoReceiptOutline } from "react-icons/io5";
import { PiCallBellDuotone } from "react-icons/pi";
import { PiCurrencyDollarFill } from "react-icons/pi";
import { IoFastFoodOutline } from "react-icons/io5";
import { FaHistory } from "react-icons/fa";
import StoreTitle from "./components/store-title";
import { usePackContext } from "./context/pack";

export const GET_STORE_LIKES = gql`
  query getStoreLikes {
    getStoreLikes {
      id
      userId
      storeId
      createdAt
      user {
        id
        name
      }
      guest {
        uuid
      }
      store {
        id
      }
    }
  }
`;

export const GET_SELLER_REPORT = gql`
  query GetSellerReport {
    getSellerReport {
      totalCustomerCount
      totalDiscountPrice
      totalLikeCount
      totalCarbonEmission
      totalReviewCount
    }
  }
`;

export const GET_PACK_UNPROCESSED_ORDER_COUNT = gql`
  query getUnProcessedPackOrderCount {
    getUnProcessedPackOrderCount
  }
`;

export const GET_NOTICE = gql`
  query latestNotice {
    latestNotice {
      title
      pageUrl
    }
  }
`;

const GET_SETTLEMENT_INFO_STATUS = gql`
  query getSettlementInfoStatus {
    seller {
      bank
      accountHolder
      accountNumber
      businessNumber
      email
      tossPaymentsSellerId
      tossSellerStatus
    }
  }
`;

const GET_LEGACY_PENDING_SETTLEMENT = gql`
  query legacyPendingSettlementPreview {
    legacyPendingSettlementPreview {
      orderCount
      settlePrice
      cutoffDate
    }
  }
`;
// 정산 방식 변경 모달: 4월 전까지 3일에 한 번 표시
const SETTLEMENT_CHANGE_KEY = "settlement_change_notice_last_seen";
const LEGACY_UNSETTLED_NOTICE_KEY = "legacy_unsettled_notice_seen";
const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;
const KAKAO_CHANNEL_URL = "http://pf.kakao.com/_xawxcRn/chat";

const BossHome = () => {
  const navigate = useNavigate();
  const { data: sellerReportData } = useQuery(GET_SELLER_REPORT, {
    fetchPolicy: "network-only",
  });
  const { data: storeLikesData } = useQuery(GET_STORE_LIKES, {
    fetchPolicy: "network-only",
  });
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isNoticeModalOpen, setIsNoticeModalOpen] = useState(false);
  const [isFeeChangeModalOpen, setIsFeeChangeModalOpen] = useState(false);
  const [isSettlementChangeModalOpen, setIsSettlementChangeModalOpen] =
    useState(false);
  const [isLegacyUnsettledModalOpen, setIsLegacyUnsettledModalOpen] =
    useState(false);
  const { data: storeData } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "cache-and-network",
  });
  const { data: noticeData } = useQuery(GET_NOTICE, {
    fetchPolicy: "cache-and-network",
  });
  const { data: settlementInfoData } = useQuery(GET_SETTLEMENT_INFO_STATUS, {
    fetchPolicy: "cache-and-network",
  });
  const { data: legacyPendingSettlementData } = useQuery(
    GET_LEGACY_PENDING_SETTLEMENT,
    {
      fetchPolicy: "cache-and-network",
    }
  );
  const { resetPacks } = usePackContext();
  const legacyPendingSettlement =
    legacyPendingSettlementData?.legacyPendingSettlementPreview;

  const seller = settlementInfoData?.seller;
  const hasSettlementInfo = Boolean(
    seller?.bank &&
      seller?.accountHolder &&
      seller?.accountNumber &&
      seller?.businessNumber &&
      seller?.email,
  );
  const isVerified =
    seller?.tossSellerStatus === "APPROVED" ||
    seller?.tossSellerStatus === "PARTIALLY_APPROVED";
  const showSettlementInfoNotice =
    Boolean(seller) && !hasSettlementInfo;
  const showVerificationNotice =
    Boolean(seller) && hasSettlementInfo && !isVerified;

  useEffect(() => {
    if (storeData) {
      const hasProducts =
        storeData?.getSellerStore?.todaysProducts &&
        storeData?.getSellerStore?.todaysProducts.length !== 0;

      setIsVisible(hasProducts);
    }
  }, [storeData]);

  // 수수료 변경사항 모달 일회성 표시 로직 (12월까지만)
  useEffect(() => {
    const hasSeenFeeChangeModal = localStorage.getItem(
      "fee_change_notice_seen",
    );
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // getMonth()는 0부터 시작하므로 +1

    // 12월까지만 모달 표시 (1월부터는 표시하지 않음)
    if (!hasSeenFeeChangeModal && currentMonth <= 12) {
      setIsFeeChangeModalOpen(true);
    }
  }, []);

  useEffect(() => {
    const now = Date.now();
    const april2026 = new Date(2026, 3, 1).getTime(); // 2026년 4월 1일
    if (now >= april2026) return;

    const lastSeen = localStorage.getItem(SETTLEMENT_CHANGE_KEY);
    const shouldShow = !lastSeen || now - Number(lastSeen) >= THREE_DAYS_MS;
    if (shouldShow) {
      setIsSettlementChangeModalOpen(true);
    }
  }, []);

  useEffect(() => {
    if (!legacyPendingSettlement?.orderCount) {
      return;
    }

    const hasSeenLegacyModal = localStorage.getItem(LEGACY_UNSETTLED_NOTICE_KEY);
    if (!hasSeenLegacyModal) {
      setIsLegacyUnsettledModalOpen(true);
    }
  }, [legacyPendingSettlement?.orderCount]);

  const handleCloseSettlementChangeModal = () => {
    setIsSettlementChangeModalOpen(false);
    localStorage.setItem(SETTLEMENT_CHANGE_KEY, Date.now().toString());
  };

  const handleCloseLegacyUnsettledModal = () => {
    setIsLegacyUnsettledModalOpen(false);
    localStorage.setItem(LEGACY_UNSETTLED_NOTICE_KEY, "true");
  };

  const handleClickLegacyKakao = () => {
    window.open(KAKAO_CHANNEL_URL, "_blank");
    handleCloseLegacyUnsettledModal();
  };

  const handleClickLegacyDetail = () => {
    window.open(SETTLEMENT_CHANGE_NOTICE_URL, "_blank");
    handleCloseLegacyUnsettledModal();
  };

  const handleViewSettlementChangeNotice = () => {
    window.open(SETTLEMENT_CHANGE_NOTICE_URL, "_blank");
    handleCloseSettlementChangeModal();
  };
  const handleOpenBottomSheet = () => {
    setIsBottomSheetOpen(true);
  };

  const handleCloseFeeChangeModal = () => {
    setIsFeeChangeModalOpen(false);
    localStorage.setItem("fee_change_notice_seen", "true");
  };

  const handleViewFeeChangeNotice = () => {
    window.open(
      "https://sellerpedia.super.site/%EC%88%98%EC%88%98%EB%A3%8C-%ED%95%A0%EC%9D%B8%EC%9C%A8-%EC%A0%95%EC%B1%85-%EB%B3%80%EA%B2%BD-%EC%95%88%EB%82%B4-1024",
      "_blank",
    );
    handleCloseFeeChangeModal();
  };

  return (
    <div className="w-full min-h-screen h-full overflow-y-scroll mx-auto bg-gray-100 pt-[65px] pb-[120px]">
      <HeaderLiveSales />
      <StoreTitle title={storeData?.getSellerStore?.title} />

      <div className="flex flex-col justify-center items-center px-4 w-full space-y-4">
        <h1 className="text-4xl font-bold text-center mt-4 mb-2 text-gray-800">
          🕒 실시간 판매
          <p className="text-md text-center text-gray-600">
            지금 올려서 바로 판매!
          </p>
        </h1>

        <div className="flex flex-col items-center space-y-2">
          <div className="shadow-md w-[230px] grid grid-cols-2">
            <button
              onClick={() => {
                track("사장님 좋아요 탭 클릭");
                navigate("/boss/likes");
              }}
              className="flex items-center justify-center bg-white text-gray-800 px-3 py-1 active:bg-gray-200 transition-colors rounded-l-lg border-r-2 border-gray-100"
            >
              <div className="flex items-center gap-2">
                <FaHeart className="text-red-500 w-5 h-5" />
                <span className="text-xl font-bold">
                  {storeLikesData?.getStoreLikes?.length || 0}개
                </span>
              </div>
            </button>

            <button
              onClick={() => {
                track("사장님 리뷰 탭 클릭");
                navigate("/boss/review");
              }}
              className="flex items-center justify-center bg-white text-gray-800 px-3 py-1 active:bg-gray-200 transition-colors rounded-r-lg"
            >
              <div className="flex items-center gap-2">
                <FaStar className="text-yellow-500 w-5 h-5" />
                <span className="text-xl font-bold">
                  {sellerReportData?.getSellerReport?.totalReviewCount || 0}개
                </span>
              </div>
            </button>
          </div>

          {/* 좋아요 수 분리하여 상세 표시 */}
          {sellerReportData?.getSellerReport ? (
            <button
              onClick={() => {
                track("사장님 리포트 탭 클릭");
                navigate("/boss/report");
              }}
              className="bg-white  w-[200px] text-[#444] rounded-lg shadow-md hover:bg-blue-50 flex items-center justify-center py-2 px-4 gap-3"
            >
              <div>
                <FaUserFriends className="text-blue-500 w-4 h-4 inline mb-0.5 mr-1" />
                <span className="font-semibold text-md">
                  {sellerReportData?.getSellerReport?.totalCustomerCount}
                </span>
              </div>
              <div>
                <FaMoneyBillWave className="text-green-600 w-4 h-4 inline mb-0.5 mr-1" />
                <span className="font-semibold text-md">
                  {sellerReportData?.getSellerReport?.totalDiscountPrice.toLocaleString()}
                </span>
              </div>

              <div>
                <FaLeaf className="text-green-500 w-4 h-4 inline mb-0.5 mr-1" />
                <span className="font-semibold text-md">
                  {sellerReportData?.getSellerReport?.totalCarbonEmission}
                </span>
              </div>
            </button>
          ) : null}
        </div>

        {noticeData?.latestNotice && (
          <div
            id="공지사항"
            onClick={() => {
              setIsNoticeModalOpen(true);
            }}
          >
            <div className="w-full h-full bg-white rounded-lg shadow-md px-4 py-2">
              <div className="flex items-center justify-center gap-2">
                <div className="text-xl font-bold">📢</div>
                <div className="text-xl font-bold underline underline-offset-4">
                  {noticeData?.latestNotice?.title}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <BossBannerTop /> */}

        {/* Button Grid */}
        <div className=" w-full max-w-md">
          <section className="grid grid-cols-2 gap-6 w-full max-w-md ">
            {/* 판매현황 */}
            <button
              onClick={() => navigate("/boss/live-order/sales")}
              className="bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <IoReceiptOutline className="w-10 h-10 text-blue-400" />
              <span className="text-lg text-[#1562fc] font-semibold">
                주문 현황
              </span>
              <div className="flex items-center justify-center animate-pulse">
                {isVisible && (
                  <span className="text-md px-2 py-1 bg-green-100 rounded-md text-green-500">
                    판매 진행중
                  </span>
                )}
              </div>
            </button>
            {/* 팩 만들기 */}
            <div className="w-full h-full ">
              <button
                onClick={() => {
                  localStorage.getItem("hideIntro") === "true"
                    ? navigate("/boss/live-order/select-from-menu")
                    : navigate("/boss/live-order/intro");

                  /**
                   * NOTE: 팩 업로드 과정에서 아래처럼 UX 문제가 있어 팩을 초기화 합니다.
                   * 1. 팩 생성
                   * 2. 뒤로가기
                   * 3. 메뉴 수정 (금액 수정)
                   * 4. 다시 판매시작
                   * 5. 두 개의 팩이 생성된 상태에서 업로드
                   */
                  resetPacks();
                }}
                className="w-full bg-white text-[#444] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
              >
                <div className="flex items-center gap-2">
                  <PiCurrencyDollarFill className="w-6 h-6 text-green-400" />
                  <PiCallBellDuotone className="w-10 h-10 text-blue-400" />
                  <PiCurrencyDollarFill className="w-6 h-6 text-green-400" />
                </div>
                <span className="text-lg text-[#1562fc] font-semibold">
                  판매시작
                  <br />( 손님에게 알리기 )
                </span>
              </button>
            </div>

            {/* 메뉴관리 */}
            <button
              onClick={() => navigate("/boss/live-order/menu-management")}
              className="bg-white text-[#1562fc] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <IoFastFoodOutline className="w-10 h-10 text-blue-400" />
              <span className="text-lg font-semibold">
                가게
                <br />
                메뉴관리
              </span>
            </button>

            {/* 메뉴관리 */}
            <button
              onClick={() => navigate("/boss/live-order/previous-sales")}
              className="bg-white text-[#1562fc] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <FaHistory className="w-10 h-10 text-blue-400" />
              <span className="text-lg font-semibold">이전 주문</span>
            </button>

            {/* 실시간 판매 공지 수정 */}
            <button
              onClick={() => navigate("/boss/live-order-notice")}
              className="bg-white text-[#1562fc] py-4 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
            >
              <PiCallBellDuotone className="w-10 h-10 text-yellow-400" />
              <span className="text-lg font-semibold">
                실시간 판매
                <br />
                공지 수정
              </span>
            </button>

            {/* 실시간 판매가 뭔가요? 버튼 추가 */}
            <div className="w-full h-full">
              <button
                onClick={handleOpenBottomSheet}
                className="w-full bg-blue-500 text-white py-6 rounded-lg shadow-md hover:bg-blue-50 transition-colors flex flex-col items-center justify-center space-y-2"
              >
                <FaQuestion className="w-10 h-10 text-white" />
                <span className="text-lg text-white font-semibold">
                  실시간판매가 뭔가요?
                </span>
              </button>
            </div>
          </section>
        </div>

        {/* 의견/건의사항 - 그리드 밑 화면 가득 */}
        <button
          onClick={() => navigate("/boss/feedback")}
          className="w-full max-w-md bg-white text-[#1562fc] rounded-lg shadow-md hover:bg-blue-50 transition-colors flex items-center justify-center gap-2 py-4 px-4"
        >
          <FaEnvelope className="w-5 h-5 text-blue-400 shrink-0" />
          <span className="text-base font-semibold">의견/건의사항</span>
        </button>
      </div>

      {/* 공지사항 모달 */}
      <NoticeModal
        isOpen={isNoticeModalOpen}
        onClose={() => setIsNoticeModalOpen(false)}
        src={noticeData?.latestNotice?.pageUrl}
        title={noticeData?.latestNotice?.title}
      />

      {/* 수수료 변경사항 모달 */}
      <FeeChangeModal
        isOpen={isFeeChangeModalOpen}
        onClose={handleCloseFeeChangeModal}
        onViewNotice={handleViewFeeChangeNotice}
      />

      {/* 정산 방식 변경 모달 (4월 전까지 주 1회) */}
      <SettlementChangeModal
        isOpen={isSettlementChangeModalOpen}
        onClose={handleCloseSettlementChangeModal}
        onViewNotice={handleViewSettlementChangeNotice}
      />

      <LegacyUnsettledModal
        isOpen={isLegacyUnsettledModalOpen}
        orderCount={legacyPendingSettlement?.orderCount ?? 0}
        settlePrice={legacyPendingSettlement?.settlePrice ?? 0}
        cutoffDate={legacyPendingSettlement?.cutoffDate ?? "2026-03-31"}
        onClose={handleCloseLegacyUnsettledModal}
        onClickKakao={handleClickLegacyKakao}
        onClickDetail={handleClickLegacyDetail}
      />

      {/* BottomSheet 컴포넌트 */}
      <BottomSheet
        isOpen={isBottomSheetOpen}
        onClose={() => setIsBottomSheetOpen(false)}
        buttonText="확인"
        onButtonClick={() => setIsBottomSheetOpen(false)}
      >
        <Swiper
          spaceBetween={50}
          slidesPerView={1}
          onSlideChange={(swiper: any) => setCurrentSlide(swiper.activeIndex)}
          className="max-w-[742px]"
        >
          <SwiperSlide>
            <div>
              <FadeInWrapper className="flex items-start ">
                <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                  1
                </div>
                <h1 className="text-2xl font-bold">
                  재고가 남았는데, <br />
                  고객들에게 알려서 팔고 싶을 때!
                </h1>
              </FadeInWrapper>
              <div className="flex justify-center items-center h-48">
                <img src={INTRO_IMG1} alt="실시간판매" className="max-h-56" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div>
              <FadeInWrapper className="flex items-start">
                <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                  2
                </div>
                <h1 className="text-2xl font-bold">
                  사장님이 직접 메뉴 선택해서 올려요
                </h1>
              </FadeInWrapper>
              <div className="flex justify-center items-center h-48">
                <img src={INTRO_IMG2} alt="실시간판매" className="max-h-56" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div>
              <FadeInWrapper className="flex items-start">
                <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                  3
                </div>
                <h1 className="text-2xl font-bold">
                  소비자는 알림을 받고 <br />
                  바로 구매하고 픽업하러 출발해요!
                </h1>
              </FadeInWrapper>
              <div className="flex justify-center items-center h-48">
                <img src={INTRO_IMG3} alt="실시간판매" className="max-h-56" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div>
              <FadeInWrapper className="flex items-start">
                <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                  4
                </div>
                <h1 className="text-2xl font-bold">
                  손님이 매장에 오면 상품을 전달해요.
                </h1>
              </FadeInWrapper>
              <div className="flex justify-center items-center h-48">
                <img src={INTRO_IMG4} alt="실시간판매" className="max-h-56" />
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div>
              <FadeInWrapper className="flex items-start">
                <h1 className="text-2xl font-bold">더 자세하게 궁금하다면?</h1>
              </FadeInWrapper>
              <div className="flex flex-col justify-center items-center h-48 overflow-y-auto">
                <button
                  onClick={() => navigate("/boss/live-order/faq")}
                  className="text-white rounded-xl border px-4 py-2 bg-blue-500 font-semibold mt-4"
                >
                  자주묻는질문 이동하기 (클릭)
                </button>
                <div className="text-lg text-gray-500 text-center mt-4">
                  ⬆️ 더 자세한 <br />
                  이야기들을 담았어요!
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>

        {/* 수동 페이지네이션 점 */}
        <div className="flex justify-center mt-4">
          {[0, 1, 2, 3, 4].map((index) => (
            <div
              key={index}
              className={`w-3 h-3 mx-1 rounded-full ${
                currentSlide === index ? "bg-blue-500" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      </BottomSheet>

      <BossBottomTab
        topNotice={
          showSettlementInfoNotice ? (
            <div className="mx-2 flex justify-center items-center rounded-t-xl bg-pink-500">
              <button
                type="button"
                onClick={() =>
                  navigate("/boss/my/banking/settlement-info-update")
                }
                className="flex w-full items-center justify-center gap-4 rounded-t-xl py-1 font-medium text-white"
              >
                <span>정산을 받으려면 계좌 정보가 필요해요</span>
                <span className="font-bold">[입력하기]</span>
              </button>
            </div>
          ) : showVerificationNotice ? (
            <div className="mx-2 flex justify-center items-center rounded-t-xl bg-amber-500">
              <button
                type="button"
                onClick={() =>
                  navigate("/boss/my/banking/settlement")
                }
                className="flex w-full items-center justify-center gap-4 rounded-t-xl py-1 font-medium text-white"
              >
                <span>정산 지급을 위해 본인인증이 필요해요</span>
                <span className="font-bold">[인증하기]</span>
              </button>
            </div>
          ) : undefined
        }
      />
    </div>
  );
};

export default BossHome;
